module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAbCAYAAACeA7ShAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAE6ADAAQAAAABAAAAGwAAAAAQHxtnAAAAt0lEQVRIDWNkoBC8UvFuZWBkyGP4zzCJkUKzGF6pev0BmsH8n4HhFxOlhoEMApkBdBUbQcNeqXofBmFiLGUhrOi/DWE1EBUEXUasQSB1g9iwl6peD0nxCj61TMAolcOngBS5QRxmpHiDkNpRbxIKIUz5QRxmwBLyEaaDyRNhEr+9TZ48rZi6Bm+YEVFsMx5h+P+fqFqMKEWYoYMQAVZ1wDiEAGqE2V+QUdSpN/8zdgLN+sr4n7EHAGxaIAN5L86eAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/seckillTip.png
// module id = 6l9X
// module chunks = 0